module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("Add Service Fee")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUserRate
    }
  }, [_vm._v("User Rate")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.serviceFees,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serviceLabel",
      "label": "Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceBaseFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceDesc",
      "label": "Desc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Category",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addServiceFee",
    attrs: {
      "model": _vm.addServiceFee,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceLabel", $$v)
      },
      expression: "addServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceBaseFee", $$v)
      },
      expression: "addServiceFee.serviceBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc",
      "prop": "serviceDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addServiceFee.serviceDesc),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceDesc", $$v)
      },
      expression: "addServiceFee.serviceDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddServiceFee($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Category",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editServiceFee",
    attrs: {
      "model": _vm.editServiceFee,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceLabel", $$v)
      },
      expression: "editServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceBaseFee", $$v)
      },
      expression: "editServiceFee.serviceBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc",
      "prop": "serviceDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editServiceFee.serviceDesc),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceDesc", $$v)
      },
      expression: "editServiceFee.serviceDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "User Rate List",
      "width": "80%",
      "visible": _vm.userRateVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.userRateVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.userRates,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasSingleSeted",
      "label": "Has bean set"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.hasSingleSeted ? "Already Set" : "Not Set") + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showServiceFeeEdit(scope.row.doctorNo)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.userRateVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Service Fee Set",
      "width": "80%",
      "visible": _vm.customServiceFeeVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customServiceFeeVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customServiceFeeConfigs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serviceLabel",
      "label": "Service Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceLabel) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceBaseFee",
      "label": "Service Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceDesc",
      "label": "Description"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceDesc) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCustomEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (scope.row.hasSingleSeted) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomItem(scope.row)
            }
          }
        }, [_vm._v("Restore")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customServiceFeeVisible = false;
        _vm.getAllUserRate()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Edit Service Fee",
      "width": "80%",
      "visible": _vm.customEditVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customEditServiceFee",
    attrs: {
      "model": _vm.customEditServiceFee,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Service Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.customEditServiceFee, "serviceLabel", $$v)
      },
      expression: "customEditServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditServiceFee, "serviceBaseFee", $$v)
      },
      expression: "customEditServiceFee.serviceBaseFee"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customEditVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.customEditLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.customEditSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b7d4a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseAdmin/serviceFeeConfig.vue
// module id = 799
// module chunks = 1